import { render, staticRenderFns } from "./MisClasesPage.vue?vue&type=template&id=ac278be8&scoped=true&"
import script from "./MisClasesPage.vue?vue&type=script&lang=js&"
export * from "./MisClasesPage.vue?vue&type=script&lang=js&"
import style0 from "./MisClasesPage.vue?vue&type=style&index=0&id=ac278be8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac278be8",
  null
  
)

export default component.exports